<template>
  <header>
    <div class="container">
      <a href="/">
        <img id="logo" src="/img/logo.png" :alt="appname" />
      </a>

      <HeaderNav :menu="menu" />

      <div class="right-wrapper">
        <a
          class="button mx-1"
          href="/register?agent_id=ffb64d59-f5b9-48dc-8c7a-6a11b984d20d"
          >
          Take your personal assessment
        </a>
        <a class="button mx-1" href="/faqs">FAQs</a>
        <a class="button mx-1" href="/uploads/files/MNLBrochure.pdf" target="_blank">Brochure</a>
      </div>
    </div>
  </header>
</template>

<script>
import HeaderNav from "./partials/HeaderNav";

export default {
  props: ["appname", "nav"],
  components: {
    HeaderNav
  },
  computed: {
    menu() {
      return JSON.parse(this.nav);
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$store.dispatch("setClientLanguage", lang);
    }
  }
};
</script>

<style lang="scss" scoped>
.languageContainer {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  img {
    cursor: pointer;
    width: 4rem !important;
    height: 2rem !important;
  }
}

@media only screen and (min-width: 501px) {
  .languageContainer {
    justify-content: flex-end;
  }
}
</style>
